import {faCogs} from "@fortawesome/pro-light-svg-icons/faCogs";
import {faCog} from "@fortawesome/pro-solid-svg-icons/faCog";
import {ActionDetails, useMailActions,} from "@twigsby/client-data";
import {Button, ColourSolid, Modal, ModalType, useNotifications, useTranslation} from "@twigsby/frontend-framework";
import {GetArrayIndexByKeyValue, StripHtml} from "@twigsby/helpers";
import {useEffect, useRef, useState} from "react";
import {useMailbox} from "../../../Providers/NewMailboxProvider";

interface ConfirmActionModalType extends ModalType {
    folderSlug: string;
    mailIds: Array<string>;
    actionId: number;
}

const ConfirmActionModal = (props: ConfirmActionModalType) => {
    const { t } = useTranslation();
    const { ActionMailItems, ActionMailItemsUi, UndoActionMailItems } = useMailbox();
    const { addToast } = useNotifications();

    const [selectedActionDetails, setSelectedActionDetails] = useState<ActionDetails | null>(null);
    const [actionActive, setActionActive] = useState<boolean>(false);

    const [timerComplete, setTimerComplete ] = useState<boolean>(props.mailIds.length <= 8);

    const mailActions: any = useMailActions();

    const ActionComplete = () => {
        setActionActive(false);
        props.actionedCallback();
    }

    const ActionItemReset = () => {
        UndoActionMailItems();
        ActionComplete();
    }

    const ActionItems = () => {
        setActionActive(true);

        props.closeCallback();

        ActionMailItemsUi(selectedActionDetails?.name as string);

        addToast({
            content: t("mailItem.messages.actionRequested"),
            colour: ColourSolid.Warning,
            icon: faCog,
            iconSpins: true,
            actionLabel: 'Undo',
            actionCallback: () => ActionItemReset(),
            onDismissedCallback: () => ActionMailItems(props.actionId, selectedActionDetails?.name as string, () => ActionComplete())
        })
    }

    const GetSelectedActionDetails = () => {
        const actionIndex = GetArrayIndexByKeyValue(mailActions.data.data, 'transitionId', props.actionId);
        setSelectedActionDetails(mailActions.data.data[actionIndex]);
    }

    useEffect(() => {
        if(mailActions?.data?.data && props.actionId !== -1) {
            GetSelectedActionDetails();
        }
    }, [mailActions.data, props]);

    const progressRef = useRef<HTMLDivElement>(null);

    const hideTimer = useRef<any>();

    const initialising = useRef<boolean>(false);
    const waitTime = 5000;

    const UpdateProgress = (value: number) => {
        if (progressRef.current) {
            progressRef.current.style.width = `${value}%`;
        }
    };

    const Initialise = () => {
        initialising.current = true;

        if (hideTimer.current) {
            clearTimeout(hideTimer.current);
        }

        if (progressRef.current) {
            progressRef.current.style.transitionDuration = `${waitTime}ms`;
        }

        setTimeout(() => {
            UpdateProgress(100);
        }, 100);

        setTimeout(() => {
            setTimerComplete(true);
        }, waitTime + 100);


        initialising.current = false;
    };

    useEffect(() => {
        if (progressRef.current) {
            Initialise();
        }
    }, []);

    return (
        <Modal
            title={`${selectedActionDetails?.name} ${props.mailIds.length} ${props.mailIds.length === 1 ? 'Item' : 'Items'}`}
            isOpen={props.isOpen}
            closeCallback={() => props.closeCallback()}
            actionedCallback={() => props.actionedCallback()}
        >
            <p>{selectedActionDetails?.prompt ? StripHtml(selectedActionDetails?.prompt as string) : selectedActionDetails?.hint}</p>

            {props.mailIds.length > 8 && (
                <div style={{margin: '0 auto 20px', textAlign: 'center'}}>
                    <div className={`progress slim`}>
                        <div
                            ref={progressRef}
                            className={`progress-inner alert`}
                            style={{width: 0, transition: `width ${waitTime}ms`, transitionTimingFunction: 'linear'}}
                        />
                    </div>
                </div>
            )}

            <Button title={'Confirm'} disabled={!timerComplete || actionActive} loading={actionActive} fullWidth={true}
                    colour={ColourSolid.Primary} onClick={() => ActionItems()}/>
        </Modal>
    )
}

export default ConfirmActionModal
